module.exports = __webpack_public_path__ + "static/media/img_fenlei08.b5d6ee3a.png";